(function () {
  var DISCOUNT_PERCENT = 15;
  var THRESHOLD = 2;

  var EXCLUDED_SKU_PREFIXES = [
    'LC517', 'LN517', 'LC504', 'LN504', 'LN505', 'LC505',
    'LN503', 'LC503', 'LN514', 'LC514', 'LN513', 'LC513',
    'LC516', 'LN516', 'LN530', 'LN520', 'LS100', 'LR-MDAYGIFTBOX'
  ];

  var BASE_STYLE = [
    'display:flex',
    'flex-direction:column',
    'gap:4px',
    'padding:12px 16px',
    'border-radius:8px',
    'font-size:14px',
    'line-height:1.5',
    'transition:background-color 0.25s ease, border-color 0.25s ease',
  ].join(';');

  var PENDING_STYLE  = 'background-color:#faf2ef;border:1px solid #D29082;color:#333';
  var UNLOCKED_STYLE = 'background-color:#edfaf3;border:1px solid #a3d9bb;color:#1a6640';

  function iconHTML(unlocked) {
    var bg     = unlocked ? '#1a6640' : '#e0e0e0';
    var color  = unlocked ? '#fff'    : '#666';
    var symbol = unlocked ? '✓'       : '%';
    return '<span aria-hidden="true" style="flex-shrink:0;width:18px;height:18px;border-radius:50%;background:' + bg + ';color:' + color + ';display:inline-flex;align-items:center;justify-content:center;font-size:11px;font-weight:600;">' + symbol + '</span>';
  }

  function isExcluded(item) {
    var sku = (item.sku || '').toUpperCase();
    return EXCLUDED_SKU_PREFIXES.some(function (prefix) {
      return sku.indexOf(prefix) === 0;
    });
  }

  function getCountFromCart(cart) {
    var qty = 0;
    var hasExcluded = false;

    cart.items.forEach(function (item) {
      if (isExcluded(item)) {
        hasExcluded = true;
      } else {
        qty += item.quantity;
      }
    });

    return { qty: qty, hasExcluded: hasExcluded };
  }

  function renderBlocks(qty, hasExcluded) {
    var isUnlocked = qty >= THRESHOLD;
    var remaining  = THRESHOLD - qty;
    var needed     = remaining > 0 ? remaining : THRESHOLD;
    var piece      = needed === 1 ? 'piece' : 'pieces';
    var style      = BASE_STYLE + ';' + (isUnlocked ? UNLOCKED_STYLE : PENDING_STYLE);

    var mainHTML = '<div style="display:flex;align-items:center;gap:10px;">'
      + (isUnlocked
        ? iconHTML(true)  + '<span>You\'ve unlocked <strong>' + DISCOUNT_PERCENT + '% off</strong> your order!</span>'
        : iconHTML(false) + '<span>Add <strong>' + needed + ' more ' + piece + '</strong> to unlock <strong>' + DISCOUNT_PERCENT + '% off</strong></span>')
      + '</div>';

    var noteHTML = hasExcluded
      ? '<span style="font-size:11px;opacity:0.6;padding-left:2px;">Custom Products/Packaging not included</span>'
      : '';

    document.querySelectorAll('.discount-block').forEach(function (block) {
      block.setAttribute('style', style);
      block.setAttribute('aria-live', 'polite');
      block.innerHTML = mainHTML + noteHTML;
    });
  }

  function refreshBlock() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var result = getCountFromCart(cart);
        renderBlocks(result.qty, result.hasExcluded);
      })
      .catch(function (err) {
        renderBlocks(0, false);
        console.error('[DiscountBlock] Cart fetch error', err);
      });
  }

  document.addEventListener('DOMContentLoaded', refreshBlock);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button[name="add"],' +
      'button[data-add-to-cart],' +
      'form[action*="/cart/add"] button[type="submit"],' +
      'form[action*="/cart/add"] input[type="submit"],' +
      'button[name="plus"],' +
      'button[name="minus"],' +
      '.quantity__button'
    );
    if (!btn) return;
    setTimeout(refreshBlock, 800);
  });

  ['cart:refresh', 'cart:change', 'cart:updated', 'cart:item-added', 'theme:cart:change', 'ajaxCart:updated'].forEach(function (evt) {
    document.addEventListener(evt, refreshBlock);
  });

  window.DiscountBlock = { sync: refreshBlock };
})();